import { Title, Image } from "../../../../src/blog/components";
import BABEL from "../../../../src/blog/migrate-legacy-code-with-babel/babel.png";
import * as React from 'react';
export default {
  Title,
  Image,
  BABEL,
  React
};